import { Wrapper } from 'components'

export const Certificates = () => {
  return (
    <>
      <div className="w-full flex-1 py-12">
        <Wrapper>
          <h2 className="uppercase text-sm font-medium text-metal-900">
            Formações
          </h2>
          <h1 className="pb-10 text-xxxl font-medium text-primary-600">
            Certificados
          </h1>
        </Wrapper>
      </div>
    </>
  )
}
